import script from "./OfferProductPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./OfferProductPicker.vue?vue&type=script&setup=true&lang=js"

import "./OfferProductPicker.vue?vue&type=style&index=0&id=d2bc6a06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2bc6a06"]])

export default __exports__